export default "__VITE_ASSET__fZv_6S9d__"